export default __webpack_public_path__ + "src/app/assets/images/chat-slide-right-img2.png";